import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DjiFlight } from '../../../core/models/dji.model';
import {
  DjiFlightTotals,
  djiDetailStatusLabel,
  formatDjiAcres,
  formatDjiApplied,
  formatDjiDuration,
  formatDjiFlightStart,
  formatDjiSpeed,
  summarizeDjiFlights
} from '../../utils/dji-flight.utils';

/**
 * DJI flights linked to a spray record whose aircraft has no logged drone
 * flight on it (ADN-2307). Flights for a logged aircraft are shown under that
 * drone flight instead (`app-dji-flight-comparison`). Renders nothing when
 * there are none.
 *
 * Area and duration come from the flight summary and show immediately; average
 * speed comes from the detailed file, which can arrive later, so each flight
 * says whether its details are still processing.
 */
@Component({
  selector: 'app-dji-flight-data',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dji-flight-data.component.html'
})
export class DjiFlightDataComponent {
  @Input() flights: DjiFlight[] = [];
  @Input() title = 'DJI Flight Data';
  /** Asks the page to reload the DJI flights, e.g. while details are still processing. */
  @Output() refresh = new EventEmitter<void>();

  readonly acres = formatDjiAcres;
  readonly applied = formatDjiApplied;
  readonly duration = formatDjiDuration;
  readonly speed = formatDjiSpeed;
  readonly startLabel = formatDjiFlightStart;
  readonly statusLabel = djiDetailStatusLabel;

  get totals(): DjiFlightTotals {
    return summarizeDjiFlights(this.flights);
  }

  get anyProcessing(): boolean {
    return this.flights.some((f) => f.detailStatus === 'processing');
  }

  trackByIntake(_index: number, flight: DjiFlight): string {
    return flight.intakeId;
  }
}
